module.exports = __webpack_public_path__ + "img/bookshelf03.d62eb8d1.jpg";